var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tableTitle",class:_vm.isFlex?'flex':''},[_c('div',{staticClass:"icon"},[(_vm.icon)?_c('span',{class:_vm.icon}):_vm._e(),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_vm._t("describe",function(){return [(_vm.describe)?_c('span',{staticClass:"proposal"},[_vm._v(_vm._s(_vm.describe))]):_vm._e()]})],2),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-767bd952","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tableHeader/index.vue
// module id = oeiU
// module chunks = 0